(function () {
	'use strict';

	angular
		.module('franchisee.components')
		.controller('CompanyFormController', CompanyFormController)

	/** @ngInject */
	function CompanyFormController($scope, $rootScope, $state, AuthenticationService, LoadingHelper,
		CompanyService, sweetAlert, DATA_EVENTS) {
		const vm = this;

		vm.changeTab = tabId => {
			vm.selectedTab = tabId;
		}

		let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_COMPANY_CHANGE, () => {
			LoadingHelper.startLoading('.loading-holder');

			initVars();
			getUnit();
		})

		$scope.$on('$destroy', () => {
			removeWatchUnit();
		})

		init();

		function getUnit() {
			const companyId = AuthenticationService.getUser().Company.Id;

			if (!companyId) {
				sweetAlert.swal({
					title: 'Não foi possível recuperar os dados da empresa!',
					text: 'Ocorreu um erro ao buscar o identificador da empresa.',
					type: 'warning',
					confirmButtonText: 'Ir para Home',
					showCancelButton: false,
					allowOutsideClick: false,
					allowEscapeKey: false
				}).then(response => {
					if (response.value) {
						LoadingHelper.stopLoading('.loading-holder');

						$state.go('app.home');
					}
				})

				return;
			}

			CompanyService
				.get(companyId)
				.then(success => {
					if (success.RegistrationDate)
						success.RegistrationDateFormatted = moment(success.RegistrationDate).format('DD/MM/YYYY HH:mm:ss');
					else
						success.RegistrationDateFormatted = '-';

					if (success.UpdateDate)
						success.UpdateDateFormatted = moment(success.UpdateDate).format('DD/MM/YYYY HH:mm:ss');
					else
						success.UpdateDateFormatted = '-';

					vm.companyData = success;

					LoadingHelper.stopLoading('.loading-holder');
				}, error => {
					LoadingHelper.stopLoading('.loading-holder');
					UtilHelper.errorCallback(error);
				})
		}

		function initVars() {
			vm.selectedTab = 1;
		}

		function init() {
			LoadingHelper.startLoading('.loading-holder');

			initVars();
			getUnit();
		}
	}
}());